module.exports = "\r\n  <router-outlet></router-outlet>\r\n  <app-alert-message class=\"alert__main\"></app-alert-message>\r\n\r\n"